window.showSubscription = false;

if (document.querySelectorAll(".Solve_B").length || document.querySelectorAll(".dandruff-lp").length) {
  window.showSubscription = true;
}

 

document.addEventListener("DOMContentLoaded", function () {
  let x = $(
    ".common-btn.product-form__submit.button.button--full-width.sticky.button--primary.mixedcartButton"
  );
  if (x) {
    $(
      ".common-btn.product-form__submit.button.button--full-width.sticky.button--primary.mixedcartButton"
    ).remove();
    $("body").append(x);
  }
  // Get all custom add to cart buttons
  const addToCartButtons = document.querySelectorAll(".mixedcartButton");

// Function to handle the AJAX request
// Function to handle the AJAX request
function addToCart(productData, button) {
  const spinner = button.querySelector(".loading__spinner");
  if (spinner) spinner.classList.remove("hidden"); // Show spinner

  button.classList.add("disabled");
  button.setAttribute("disabled", "disabled");

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: productData }), // Send all items in one request
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add item to cart");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Items added:", data);
      // Optional: Show confirmation popup or update cart drawer
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      if (spinner) spinner.classList.add("hidden"); // Hide spinner
      button.classList.remove("disabled");
      button.removeAttribute("disabled");
    });
}


// Attach event listeners to each button
addToCartButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const variantId = this.getAttribute("data-product-id");
    const quantityInput = document.querySelector(".quantity__input");
    const quantity = parseInt(quantityInput?.value || "1", 10);

    let number = null;
    if ($("#subsPackageRadioCustom").is(":checked")) {
      number = $('input[name="selling_plan"]:checked').val();
    }

    let cartItems = [
      {
        id: variantId,
        quantity: quantity,
        selling_plan: number,
      },
    ];

    const offerProducts = Array.from(document.querySelectorAll(".offerProductId")).map((input) => ({
      id: parseInt(input.getAttribute("offerproductid"), 10),
      quantity: 1,
      price: 0,
    }));
    cartItems = cartItems.concat(offerProducts);

    const toggle = document.getElementById("discountToggle");
    if (toggle && toggle.checked) {
      const discountOfferProducts = Array.from(document.querySelectorAll(".discountofferProductId")).map((input) => ({
        id: parseInt(input.getAttribute("discountofferproductid"), 10),
        quantity: 1,
      }));
      cartItems = cartItems.concat(discountOfferProducts);
    }

    // 🔄 Pass `this` as the button to control spinner
    addToCart(cartItems, this);
  });
});

// if (!window.showSubscription) {
//  // Toggle sellingplan-wrapper based on selected radio button
// $('input[name="package_selection"]').on('change', function () {
//   if ($('#subsPackageRadioCustom').is(':checked')) {
//     $('.sellingplan-wrapper').show();
//   } else if ($('#oneTimeRadioCustom').is(':checked')) {
//     $('.sellingplan-wrapper').hide();
//   }
// });

// // Optional: run on page load to apply correct state
// $(document).ready(function () {
//   if ($('#subsPackageRadioCustom').is(':checked')) {
//     $('.sellingplan-wrapper').show();
//   } else if ($('#oneTimeRadioCustom').is(':checked')) {
//     $('.sellingplan-wrapper').hide();
//   }
// }); 
// }


  var purchaseAreaLink = document.querySelectorAll('a[href="#purchaseArea"]');
  if (purchaseAreaLink.length) {
    purchaseAreaLink.forEach(purchaseArea => {
        purchaseArea.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent the default anchor click behavior
        //console.log('ggggg');

        const element = document.getElementById('purchaseArea');
        const offset = window.innerWidth < 750 ? 80 : 45; 
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        }); 

        // var purchaseArea = document.querySelector("#purchaseArea");
        // if (purchaseArea) {
        //   purchaseArea.scrollIntoView({ top: 300 ,behavior: "smooth" }); 
        // }
      });
    });
  }
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);

    const menuDrawer = document.getElementById("menu-drawer");
    menuDrawer.classList.add("closing");

    // Wait for the transition to end before hiding
    menuDrawer.addEventListener("transitionend", function handler() {
      menuDrawer.classList.remove("closing");
      menuDrawer.style.display = "none";
      menuDrawer.removeEventListener("transitionend", handler); // Remove the event listener after it fires
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header?.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header?.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header?.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector(".announcement-bar-slider")) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia("(min-width: 750px)");
      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener("change", () => {
          if (this.slider.getAttribute("data-autoplay") === "true")
            this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ||
      this.announcementBarArrowButtonWasClicked ||
      !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (
      this.querySelector(".announcement-bar-slider").contains(event.target)
    ) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);

    // console.log(this.currentVariant.featured_media.id);
    var slideno = $(
      '.main-media-wraper .items-inner[data-mediaid="' +
        this.currentVariant.featured_media.id +
        '"]'
    ).attr("data-slick-index");
    $(".main-media-wraper").slick("slickGoTo", slideno);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    $(".selected-option-name").html(this.currentVariant.title);
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.2877 16.9772C11.0697 16.9772 11.7045 17.6544 11.7045 18.4886C11.7045 19.3228 11.0697 20 10.2877 20C9.50573 20 8.87099 19.3228 8.87099 18.4886C8.87099 17.6544 9.50573 16.9772 10.2877 16.9772ZM16.4499 16.9772C17.2319 16.9772 17.8667 17.6544 17.8667 18.4886C17.8667 19.3228 17.2319 20 16.4499 20C15.6679 20 15.0332 19.3228 15.0332 18.4886C15.0332 17.6544 15.6679 16.9772 16.4499 16.9772ZM0.880617 1.87892H2.88208C3.27167 1.87892 3.61405 2.15625 3.71832 2.55759C3.71832 2.55759 3.71902 2.55759 3.71902 2.55834C4.39322 5.1475 5.85012 10.7422 6.52714 13.3411C6.84486 14.5624 7.88751 15.4072 9.07458 15.4072H17.6285C18.8424 15.4072 19.9005 14.5256 20.1943 13.2689C20.7903 10.7279 21.9739 5.6766 21.9739 5.6766C22.0394 5.39626 21.9802 5.09864 21.8132 4.87092C21.6463 4.64244 21.3905 4.50941 21.1193 4.50941H8.87099C8.38489 4.50941 7.99037 4.93029 7.99037 5.44887C7.99037 5.96746 8.38489 6.38834 8.87099 6.38834H19.9914L18.4852 12.815C18.3873 13.2344 18.0336 13.5282 17.6285 13.5282H9.07458C8.67795 13.5282 8.32994 13.2457 8.22356 12.8383C7.54654 10.2394 6.08964 4.64394 5.41544 2.05479C5.10054 0.841006 4.06352 0 2.88208 0H0.880617C0.394517 0 0 0.420878 0 0.939461C0 1.45804 0.394517 1.87892 0.880617 1.87892Z" fill="black"/></svg> ' +
        window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            $(".related-products-slider").slick({
              dots: false,
              infinite: false,
              speed: 300,
              slidesToShow: 4,
              slidesToScroll: 1,
              prevArrow:
                "<span class='left-ar'><img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0779/3685/3266/files/LEFT.png?v=1690876578'></span>",
              nextArrow:
                "<span class='right-ar'><img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0779/3685/3266/files/RIGHT.png?v=1690876578'></span>",
              responsive: [
                {
                  breakpoint: 1199,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                  },
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);
$(".main-media-wraper").on(
  "init reInit afterChange",
  function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    // console.log(i + '/' + slick.slideCount);
    $(".number-navigation-slider").html(i + " of " + slick.slideCount);
  }
);
if ($(window).width() < 991) {
  $(".main-media-wraper").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
     adaptiveHeight: true,
    arrows: true,
    asNavFor: ".thumnail-media-wraper",
    prevArrow:
      '<div class="a-left control-c prev slick-prev"><svg width="18" height="30" viewBox="0 0 18 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <line x1="16.7071" y1="0.706496" x2="2.70711" y2="14.7065" stroke="white" stroke-width="2"/> <line y1="-1" x2="21.2597" y2="-1" transform="matrix(-0.752536 -0.658551 0.705608 -0.708602 17.9988 28)" stroke="white" stroke-width="2"/> </svg></div>',
    nextArrow:
      '<div class="a-right control-c next slick-next"><svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <line y1="-1" x2="21.2598" y2="-1" transform="matrix(0.752592 -0.658487 0.705547 0.708663 2 30)" stroke="white" stroke-width="2"/> <line y1="-1" x2="21.2597" y2="-1" transform="matrix(0.752536 0.658551 -0.705608 0.708602 2.00122 2)" stroke="white" stroke-width="2"/> </svg></div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          adaptiveHeight: true,
          dots: true,
          slidesToShow: 1,
          //  ,
          // appendDots: $('.slider-dots-mobile'),
          // prevArrow:".left-arrow-mobile",
          // nextArrow:".right-arrow-mobile"
        },
      },
    ],
  });
} else {
  $(".main-media-wraper").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
     adaptiveHeight: true,
    arrows: true,
    asNavFor: ".thumnail-media-wraper",
   prevArrow:
      '<div class="a-left control-c prev slick-prev"><svg width="18" height="30" viewBox="0 0 18 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <line x1="16.7071" y1="0.706496" x2="2.70711" y2="14.7065" stroke="white" stroke-width="2"/> <line y1="-1" x2="21.2597" y2="-1" transform="matrix(-0.752536 -0.658551 0.705608 -0.708602 17.9988 28)" stroke="white" stroke-width="2"/> </svg></div>',
    nextArrow:
      '<div class="a-right control-c next slick-next"><svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <line y1="-1" x2="21.2598" y2="-1" transform="matrix(0.752592 -0.658487 0.705547 0.708663 2 30)" stroke="white" stroke-width="2"/> <line y1="-1" x2="21.2597" y2="-1" transform="matrix(0.752536 0.658551 -0.705608 0.708602 2.00122 2)" stroke="white" stroke-width="2"/> </svg></div>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          adaptiveHeight: true,
          dots: true,
          //  ,
          // appendDots: $('.slider-dots-mobile'),
prevArrow:
          '<div class="a-left control-c prev slick-prev"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 12.6666L3.33333 7.99998L8 3.33331" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.6667 8H3.33333" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        nextArrow:
          '<div class="a-right control-c next slick-next"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33334 8H12.6667" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 3.33331L12.6667 7.99998L8 12.6666" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
        },
      },
    ],
  });
}

$(".thumnail-media-wraper").slick({
  infinite: false,
  vertical: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: ".main-media-wraper",
  focusOnSelect: true,
  verticalSwiping: false,
  dots: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        adaptiveHeight: false,
        dots: true,
        vertical: false,
        verticalSwiping: false,
              slidesToShow: 5,
      slidesToScroll: 1,
      },
    },
        {
      breakpoint: 551,
      settings: {
      slidesToShow: 7,
      },
    },
  ],
});

$('[data-fancybox="gallery"]').fancybox({
  // Options will go here
});

$(document).on(
  "click",
  ".mega-menu-main-wraper .list-menu__item",
  function (event) {
    if ($(this).hasClass("sub-menu-dropdown-custom")) {
      event.preventDefault();
      if (
        $(this)
          .parents(".mega-menu-main-wraper")
          .hasClass("open-megamenu-wraper")
      ) {
        $(".mega-menu-main-wraper").removeClass("open-megamenu-wraper");
        $("body").removeClass("active-megamenu-body");
      } else {
        $(".mega-menu-main-wraper").removeClass("open-megamenu-wraper");
        $("body").addClass("active-megamenu-body");
        $(this)
          .parents(".mega-menu-main-wraper")
          .toggleClass("open-megamenu-wraper");
      }
    }
  }
);

// $(".mega-menu-main-wraper").hover(
//   function () {
//     $(this).addClass("active-megamenu");
//     $('body').addClass('active-megamenu-body');
//   },
//   function () {
//     $(this).removeClass("active-megamenu");
//     $('body').removeClass('active-megamenu-body');
//   }
// );

$(document).on("click", "span.menu-icon-drawer", function () {
  // $('span.menu-icon-drawer').removeClass('active');
  $(this).toggleClass("open");
  //$('li.mobile-mega-menu-li-drawer').removeClass('active');
  $(this).parents("li.mobile-mega-menu-li-drawer").toggleClass("active");
});

// $(document).on('change','.custom-block-selling-plan',function(){
//     var get_value = $(this).val();
//     if(get_value == 'One Time'){
//       $('.appstle_one_time_details_wrapper label').trigger('click');
//     }else{
//       $('.appstle_subscription_radio_wrapper label').trigger('click');
//       var get_id = $('.appstle_subscribe_option').find('input:checked').val();
//       var get_name = $('.custom-subcription-create').find('.custom-get-selling-plan[data-id="'+get_id+'"]').data('name');
//       $('.select-paln-name').html('Every '+get_name);
//     }

//   })

var myInterval = setInterval(function () {
  if ($(".subscription-widget-custom").children().length > 0) {
    $(".appstle_subscription_radio_wrapper .appstle_radio_label")
      .find(".appstle_subscribe_save_text")
      .remove();
    var get_discount =
      product_json.selling_plan_groups[0].selling_plans[0].price_adjustments[0]
        .value;
    $(".appstle_subscription_radio_wrapper .appstle_radio_label").append(
      '<div class="custom-append-div-sub"><span class="appstle_subscribe_save_text">Subscribe <span class="save-text">Save ' +
        get_discount +
        '%</span></span><span class="custom-des-sub">No commitment, cancel anytime</span><p class="select-op" data-bs-toggle="modal" data-bs-target="#exampleModal">Ships <span></span></p></div>'
    );
    //$('.appstle_subscription_radio_wrapper').after('<div class="custom-append-div-option"><p class="select-op" data-bs-toggle="modal" data-bs-target="#exampleModal">Ships <span></span></p><p class="custom-des">No commitment, cancel anytime</p></div>');
    update_plan();
    clearInterval(myInterval);
  }
}, 1000);

function update_plan() {
  var get_id = $(".appstle_subscribe_option").find("input:checked").val();
  var get_name = $(
    '.product-subscription-po .custom-popup-options-subscription .th__modal--option[value="' +
      get_id +
      '"]'
  ).data("name");
  $(".product-subscription-po .th__modal--option-label").removeClass("active");
  $(".select-op span").html("Every " + get_name);
  $(".sticky-selected-plan").html(
    'Subscribe<span class="sticky-every ">Every ' + get_name + "</span>"
  );
  var get_price = $(
    ".appstle-active-option .appstle_subscription_amount"
  ).text();
  $(".sticky-price").html(get_price);
  $(
    '.product-subscription-po .custom-popup-options-subscription .th__modal--option[value="' +
      get_id +
      '"]'
  )
    .parents(".th__modal--option-label")
    .addClass("active");
  $(
    '.product-subscription-po .custom-popup-options-subscription .th__modal--option[value="' +
      get_id +
      '"]'
  ).prop("checked", true);
}
$(document).on(
  "change",
  '.appstle_subscription_wrapper_option input[name="selling_plan"]',
  function () {
    var get_value = $(this).val();
    if (get_value == "") {
      $(".sticky-selected-plan").html("One-Time");
      $(".stiky-subscription-option").removeClass("active");
      $(".sticky-onetime-wraper").addClass("active");
    } else {
      var get_text = $(".select-op span").text();
      $(".sticky-selected-plan").html(
        'Subscribe<span class="sticky-every">' + get_text + "</span>"
      );
      $(".stiky-subscription-option").removeClass("active");
      $(".sticky-subscribe-wraper").addClass("active");
    }
    var get_price = $(
      ".appstle-active-option .appstle_subscription_amount"
    ).text();
    var get_discount =
      product_json.selling_plan_groups[0].selling_plans[0].price_adjustments[0]
        .value;
    $(".sticky-price").html(get_price);
    $(".appstle_subscribe_save_text").html(
      'Subscribe <span class="save-text"> Save ' + get_discount + "%</span>"
    );
  }
);
$(document).on(
  "change",
  ".product-subscription-po .th__modal--option",
  function () {
    console.log("change");
    $(".product-subscription-po .th__modal--option-label").removeClass(
      "active"
    );
    $(this).parents(".th__modal--option-label").addClass("active");
    var get_id = $(this).val();
    var get_name = $(this).data("name");
    $(".select-op span").html("Every " + get_name);
    $(".sticky-selected-plan").html(
      'Subscribe<span class="sticky-every">Every ' + get_text + "</span>"
    );
    // $(this).parents(".th__modal--option-label").addClass("active");
    $(
      '.appstle_subscribe_option .appstle-radio-input-wrapper input[value="' +
        get_id +
        '"]'
    ).trigger("click");
    var get_price = $(
      ".appstle-active-option .appstle_subscription_amount"
    ).text();
    $(".sticky-price").html(get_price);
    var get_discount =
      product_json.selling_plan_groups[0].selling_plans[0].price_adjustments[0]
        .value;
    $(".appstle_subscribe_save_text").html(
      'Subscribe <span class="save-text">Save ' + get_discount + "%</span>"
    );
  }
);

$(document).on(
  "click",
  ".product-subscription-po .custom-trigger-button-addtocart",
  function () {
    $("#exampleModal .btn-close").trigger("click");
    $(".product-form__submit").trigger("click");
  }
);
$(document).on("click", ".sticky-addtocart-button-trigger", function () {
  $(".product-form__submit").trigger("click");
});

$(window).scroll(function () {
  var height = $(window).scrollTop();

  var $footer = $("footer.footer");
  var $submit = $(".product-form__submit");
  var $stickyWrap = $(".sticky-addtocart-main-wraper");

  // अगर sticky wrapper ही नहीं है तो आगे कुछ मत करो
  if (!$stickyWrap.length) return;

  // footer और submit elements के लिए offset checks
  var offset_filter_top = $submit.length ? $submit.offset().top : 0;
  var get_footer = $footer.length ? $footer.offset().top : Number.MAX_SAFE_INTEGER;

  // footer cross करने पर sticky हटाओ
  if (height > get_footer) {
    $stickyWrap.removeClass("start-sticky-addtocart");
  } else {
    // product-form__submit cross करने पर sticky जोड़ो
    if (height > offset_filter_top) {
      $stickyWrap.addClass("start-sticky-addtocart");
    } else {
      $stickyWrap.removeClass("start-sticky-addtocart");
    }
  }
});


$(document).on(
  "change",
  ".card-products-subscription-redio input",
  function () {
    $(".card-products-subscription-redio label").removeClass("active");
    $(this).parents("label").addClass("active");
  }
);
$(".menu-drawer-container .header__icon--menu").click(function () {
  $("body").toggleClass("open-mobile-drawer");
});
$(document).on("click", ".sticky-variant", function (event) {
  if (!$(event.target).closest(".sticky-every").length) {
    $(".sticky-options-select-popup").show();
  }
});
$(document).on("click", ".stiky-subscription-option", function () {
  if (!$(this).hasClass("active")) {
    if ($(this).hasClass("sticky-onetime-wraper")) {
      $('.appstle_one_time_details_wrapper input[name="selling_plan"]').trigger(
        "click"
      );
    } else {
      $(
        '.appstle_subscription_radio_wrapper input[name="selling_plan"]'
      ).trigger("click");
    }
  }
  $(".sticky-options-select-popup").hide();
});
$(document).on("click", ".sticky-every", function () {
  $(".select-op").trigger("click");
});

// ✅ Append text to element
const box = document.querySelector(".custom-append-div-sub");
const text = document.createTextNode(" tutorial");
if (box && text) {
  console.log(box);
  box.append(text);
}
